import { Fragment, useContext, useState } from "react";
import { Button } from "rizzui";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import cn from "../../../utils/classNames";
import SpeciesList from "./SpeciesList";

const SpeciesListWrapper = () => {

    // STATES

    const [isOpen, setIsOpen] = useState(false);
    const [isOpenImport, setIsOpenImport] = useState(false);

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Gestión de especies' },
        { name: 'Especies', href: menuRoutes.users.path },
    ];

    // HOOKS

    const { userCan } = useContext(PrivilegeContext);

    // RENDER

    return (
        <Fragment>
            <FiltersProvider>
                <PageHeader title="Listado de especies" breadcrumb={breadCrumb}>
                    {
                        userCan('create', 'species') &&
                        (
                            <div className="flex flex-col md:flex-row gap-2">
                                <Button
                                    color="primary"
                                    onClick={() => { setIsOpenImport(true); }}
                                    className={cn(['mt-4 md:mt-0'])}
                                >
                                    Importar especies
                                </Button>
                                <Button
                                    color="primary"
                                    onClick={() => {  setIsOpen(true); }}
                                    className={cn(['mt-4 md:mt-0'])}
                                >
                                    Crear especie
                                </Button>
                            </div>
                        )
                    }

                </PageHeader>
                <SpeciesList isOpen={isOpen} setIsOpen={setIsOpen} isOpenImport={isOpenImport} setIsOpenImport={setIsOpenImport} />
            </FiltersProvider>

        </Fragment>
    );
}

export default SpeciesListWrapper;